"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HIDE_ALL = 0;
exports.DISPLAY_MENU = function (id) { return "DISPLAY_" + id; };
//# sourceMappingURL=actions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-contexify/lib/utils/actions.js
// module id = 47
// module chunks = 0